const secretFightingArts = [
    {
        "name": "Beast of Caratosis",
        "definition": "You may Concentrate. If you do, perform Beast of Caratosis at the start of your next act.",
        "notes": "Beast of Caratosis: You reach into the dream and disappear in a shimmer of heat. Place your survivor adjacent to the monster. "+
                  "Activate a weapon in your grid and attack the monster. For this attack, your attack speed is equal to your red affinities, you hit automatically, and you gain strength equal to double your red affinities. Then, gain +6 Hunt XP.",
        "expansion": "core"
    },
    {
        "name": "Bone Whisperer",
        "definition": "When another survivor dies on the showdown board, place a token where they died. If you pass over it, remove the token and eat their skull. Heal your survivor and roll 1d10 + your Hunt XP ",                      
        "notes": "1d10 Result 1 - 3 You feel amazing! Gain +1 permanent movement, speed, and evasion. 4 - 8 Gain +1 permanent strength. 9 - 18 Gain a fighting art and +5 survival. 19+ You run away into exile. At the end of the showdown you are gone forever.",
        "expansion": "core"
    },
    {
        "name": "Grace of Dormenatus",
        "definition": "You may Concentrate. If you do, perform Grace of Dormenatus at the start of your next act.",
        "notes": "Grace of Dormenatus: You reach into the dream and remove a twisting green crown. The crown explodes. A glittering rain of shards coats the survivors. "+
                  "All survivors gain armor at all hit locations equal to your green affinities. They may remove up to the same number of tokens. Then, gain +6 Hunt XP. If you still exist, gain the priority target token.",
        "expansion": "core"
    },
    {
        "name": "King of a Thousand Battles",
        "definition": "Gain +2 accuracy, +2 strength, +2 evasion. You may dodge any number of times in a round. Only 1 survivor may have this Secret Fighting Art.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "King's Step",
        "definition": "Whenever you attack, you may discard any number of Battle Pressure hit locations drawn and draw an equal number of new hit locations. "+
                      "Whenever you attack, after drawing hit locations, but before rolling to wound, you may choose one hit location drawn and discard it to draw a new hit location. Traps will cancel these effects.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Legendary Lungs",
        "definition": "Once per attack, for each successful hit, make an additional attack roll.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Lucernae's Lantern",
        "definition": "You may Concentrate. If you do, perform Lucernae's Lantern at the start of your next act. Lucernae's Lantern: You reach into the dream and excise a screeching skull, darker than darkness. "+
                      "It hurtles at the monster. Reveal hit locations equal to half your blue affinities (rounded down) one at a time. "+
                      "The monster suffers a critical wound at any locations with critical wound effects (Ignore the effects of the trap.) Then reshuffle the hit location deck. Gain +6 Hunt XP.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Red Fist",
        "definition": "At the start of each showdown, each survivor gains +1 strength token. Survivors may spend +1 strength tokens in place of survival.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Scholar of Death",
        "definition": "On Arrival, gain reroll tokens equal to the number of volumes recorded about your quarry. (e.g., if your settlement has White Lion Volumes 1, 2 and 3, when you fight a White Lion, gain 3 reroll tokens.) "+
                      "Discard a reroll token to reroll one of your results during the showdown. This includes monster roll results when you are the monster controller.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Swordsman's Promise",
        "definition": "On Arrival, gain survival up to your settlement's Survival Limit if you have a sword in your gear grid.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Synchronized Strike",
        "definition": "With flawless coordination, you strike as one. When you're adjacent to a monster, attack with a melee weapon, and have an Attack Assist. "+
                      "Your attack gains +1 accuracy, +1 strength. Limit, once per round. Attack Assist: A survivor who also has Synchronized Strike and is in the right spot. They are standing adjacent to the monster on its opposite side, and parallel to you.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Zero Presence",
        "definition": "Gain +1 strength when attacking a monster from its blind spot. Whenever you attack a monster, you are always considered to be in its blind spot.",
        "notes": null,
        "expansion": "core"
    },
    {
        "name": "Altered Destiny",
        "definition": "If you would gain a negative attribute token, gain a positive attribute token of that type instead.",
        "notes": null,
        "expansion": "Dragon King"
    },
    {
        "name": "Frozen Star",
        "definition": "Once per round, you may spend 1 survival to freeze a monster's brain. They gain -2 accuracy until the end of the round. Once per round, you may spend 1 survival to freeze a survivor's brain, killing them instantly. They die.",
        "notes": null,
        "expansion": "Dragon King"
    },
    {
        "name": "Beetle Strength",
        "definition": "Once per showdown, you may spend Activation to shove an adjacent obstacle terrain. If you do, move the terrain directly away from you in a straight line until it encounters a board edge or another obstacle terrain. "+
                      "Any monsters the terrain passes over suffer a wound, and any survivors it collides with suffer knockback 7. The display of strength is so exhausting it ages you. You are knocked down and gain +1 Hunt XP.",
        "notes": null,
        "expansion": "Dung Beetle Knight"
    },
    {
        "name": "Acanthus Doctor",
        "definition": "You may wear up to 3 Satchel gear cards. When you depart, if you are not wearing any armor, for each Green Affinity Box you have, gain +1 strength token and add 1 to all hit locations. "+
                      "Spend Activation and a Flower Resource or Fresh Acanthus resource to heal a permanent injury you or an adjacent survivor suffered this showdown.",
        "notes": null,
        "expansion": "Flower Knight"
    },
    {
        "name": "Fencing",
        "definition": "Ignore Parry when attempting to wound hit locations. (Attempt to wound these locations normally.) When a monster attacks you, roll 1d10. On a 6+, ignore 1 hit. Limit, once per round.",
        "notes": null,
        "expansion": "Flower Knight"
    },
    {
        "name": "True Blade",
        "definition": "All swords in your gear grid gain deadly. Gain +3 luck when attacking with a sword if you have the Ghostly Beauty and Narcissistic disorders.",
        "notes": null,
        "expansion": "Flower Knight"
    },
    {
        "name": "Aerial transfusion",
        "definition": "It requires an additional two bleeding tokens to kill you. During your act, you may spend Activation to freely rearrange all survivors' bleeding tokens.",
        "notes": null,
        "expansion": "Crimson Crocodile"
    },
    {
        "name": "Devil's Melody",
        "definition": "Ballad of the Devil's Melody [4]: Gain +10 Survival, +10 Insanity, +1 Movement token, and +1 Speed token. At the start of each round, the monster suffers an automatic Wound and each survivor suffers a random Severe Injury.",
        "notes": null,
        "expansion": "Smog Singers"
    },
    {
        "name": "Mind Palace",
        "definition": "When you Depart or gain this, choose a Fighting Arts from the deck. For the rest of the lantern year, treat the effects of the chosen card as an ability.",
        "notes": null,
        "expansion": "King"
    },
    {
        "name": "Actualize",
        "definition": "Gain +1 speed when attacking with a sword. After you make attack rolls with a sword, you may discard a roll result to increase another roll result by 1. "+
                      "You may do this as many times as you like, so long as there is at least 1 attack roll result left.",
        "notes": null,
        "expansion": "Atnas"
    },
    {
        "name": "God of Cheaters",
        "definition": "Gain +4 Luck. Add your luck attribute to your strength and evasion Attributes.",
        "notes": null,
        "expansion": "Gambler"
    },
    {
        "name": "Immovable Object",
        "definition": "If you are an unoccupied space, you stand firm in the face of any force. You cannot be knocked down and may ignore knockback. "+
                      "(If you occupy the same space as a monster, an impassable terrain tile, or another survivor, you are knocked down and suffer knockback.)",
        "notes": null,
        "expansion": "Gorm"
    },
    {
        "name": "Necromancer",
        "definition": "When you depart, gain +1 to all hit locations for each gear card in your grid with the symbol keyword. If you would roll on the severe injury table, roll on the Worm Trauma table on the other side of this card instead. "+
                      "When you die or forget this, the settlement gains the The Knowledge Worm innovation.",
        "notes": "Worm Trauma: Whenever you would suffer an unspecified severe injury, roll 1d10 on the following table instead of on the severe injury table. (Specified severe injuries remain unchanged.) "+
                 "1d10 Result 1 - 3 A spray of blood and silver. Dead. 4 - 5 The worm's coil tightens sharply. Gain 2 bleeding tokens and -1 evasion token. 6 - 7 A dizzying blow. Gain 1 bleeding token and 1d5 insanity. "+
                 "8 An inhuman voice screams in your bones. Gain 1 bleeding token and 1d5 insanity. 9 The pain is infuriating! Gain 1 bleeding token and +1 strength token. 10 Molten metal issues from your mouth. You are knocked down and gain 1 Iron strange resource.",
        "expansion": "Lion God"
    },
    {
        "name": "Ageless Apprentice",
        "definition": "When you gain Hunt XP, you may decide not to gain it. When you depart, you may rotate up to 3 gear cards in your gear grid. This changes the location of their affinities and arrows. Otherwise, the gear functions normally.",
        "notes": null,
        "expansion": "Lion Knight"
    },
    {
        "name": "Courtly Screenwriter",
        "definition": "On Arrival, secretly write down on a scrap of paper which survivors will live and who will deal the killing blow. During the aftermath, if your predictions were correct, raise the settlement's Survival Limit by 1.",
        "notes": null,
        "expansion": "Lion Knight"
    },
    {
        "name": "Eternal Will",
        "definition": "Gain +1 accuracy and +1 strength for each permanent injury you have. You may always depart, even when retired.",
        "notes": null,
        "expansion": "Manhunter"
    },
    {
        "name": "Black Guard Style",
        "definition": "Swords in your gear grid gain Block 1. When you block a hit with a sword, your next attack that round with a sword gains +2 accuracy. +2 strength, and +2 speed. "+
                      "Limit, once per round. During the settlement phase, you may spend Endeavor to train a survivor. They gain the Black Guard Style secret fighting art. You lose it and suffer the broken arm severe injury.",
        "notes": null,
        "expansion": "Whitebox: Percival"
    },
    {
        "name": "Clarity of Darkness",
        "definition": "On Arrival, gain the Path of Gloom survivor status card. There is a deadly, otherworldly presence about you. Other survivors cannot voluntarily end their movement adjacent to you.",
        "notes": null,
        "expansion": "Slenderman"
    },
    {
        "name": "Death Touch",
        "definition": "Gain +1 accuracy when attacking with Fist & Tooth. When you wound a monster, it gains -1 toughness until the end of your attack. You cannot use this if you are male.",
        "notes": null,
        "expansion": "Spidicules"
    },
    {
        "name": "Silk Surgeon",
        "definition": "Rank 1 You may spend Activation while adjacent to another survivor to add 2 to one of their hit locations. Rank 2 While all armor in your gear grid is silk and all jewelry is amber, gain +2 evasion. "+
                      "Rank 3 During the aftermath, roll 1d10 for each other survivor that died during the showdown. On a 7+, revive them.",
        "notes": "Silk Surgeon begins at Rank 0, and may be upgraded through the Silk Surgery story event. Record the rank of Silk Surgeon on the survivor record sheet. "+
                 "The bonuses granted by the different ranks are cumulative: A survivor who is rank 2 will gain all benefits granted by rank 1 and rank 2 of Silk Surgeon.",
        "expansion": "Spidicules"
    },
    {
        "name": "Hellfire",
        "definition": "You cannot lose or remove this fighting art. Gain +1 strength for each Red Affinity Box you have. You cannot be nominated for Intimacy. "+
                      "You ignore Extreme Heat. At the start of your act, lose 1 survival. At the end of your act, if your survival is 0 or you have any +1 strength tokens, your organs cook themselves and you die.",
        "notes": null,
        "expansion": "Sunstalker"
    },
    {
        "name": "Sun Eater",
        "definition": "Your body mysteriously absorbs light. On Arrival, gain survival up to the settlement's Survival Limit. If you have any +1 strength tokens, you may spend them all to perform the Surge survival action (following all of its normal rules and restrictions).",
        "notes": null,
        "expansion": "Sunstalker"
    },
    {
        "name": "Suppressed Shadow",
        "definition": "You no longer cast a shadow and you never hesitate. Ignore First Strike. On a Perfect hit, your first wound attempt of the attack automatically succeeds and inflicts a critical wound. "+
                      "If you die during the showdown, place a Shade minion in the space you occupied.",
        "notes": null,
        "expansion": "Sunstalker"
    },
    {
        "name": "Joyous",
        "definition": "Whenever you would suffer brain damage, gain that much insanity instead. When you have 100 insanity you die.",
        "notes": null,
        "expansion": "Elgnirk"
    },
];


export default secretFightingArts;